import { MdOutlineRemoveCircle } from 'react-icons/md';
import { PostalCodeTableData } from '../../../types/postalCodes';

const PostalCodeModalTable = ({
  addedPostalCodeList,
  removeAddedPostalCode,
}: {
  addedPostalCodeList: Array<PostalCodeTableData>;
  removeAddedPostalCode: (postalCode: string) => void;
}) => {
  // rendering postal code modal table component here
  return (
    <div className='border-2 border-dashed border-base-dark-blue rounded-lg'>
      <div className='grid grid-cols-[1fr_1fr_150px_50px] text-center text-base-dark-blue font-semibold [&>p]:py-1 [&>p:not(:last-child)]:border-r [&>p:not(:last-child)]:border-dashed [&>p:not(:last-child)]:border-base-dark-blue border-b-2 border-dashed border-legal-dark-blue'>
        <p>Province</p>
        <p>City</p>
        <p>Postal Code</p>
        <p></p>
      </div>

      <div className='[&>div:not(:last-child)]:border-b [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-base-dark-blue'>
        {addedPostalCodeList.map((postalCode, index) => (
          <div
            key={index}
            className='grid grid-cols-[1fr_1fr_150px_50px] text-center text-base-dark-blue [&>div]:py-1 [&>div:not(:last-child)]:border-r [&>div:not(:last-child)]:border-dashed [&>div:not(:last-child)]:border-base-dark-blue'
          >
            <div>
              <p>{postalCode.province.name}</p>
            </div>

            <div>
              <p>{postalCode.city.name}</p>
            </div>

            <div>
              <p>{postalCode.postal_code}</p>
            </div>

            <div className='flex items-center justify-center'>
              <button
                title='Remove Postal Code'
                type='button'
                onClick={() => removeAddedPostalCode(postalCode.postal_code)}
                className='hover:opacity-70 duration-300'
              >
                <MdOutlineRemoveCircle className='size-5 text-base-red' />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostalCodeModalTable;
